import adminGuard from '@/guards/adminGuard';
import authGuard from '@/guards/authGuard';
import orderGuard from '@/guards/orderGuard';
import AuthLogoutRedirectView from '@/views/AuthLogoutRedirectView.vue';
import MainView from '@/views/StartChooseLocationView.vue';
import { createRouter, createWebHistory } from 'vue-router';

import { RouteNames } from './routeNames';

const router = createRouter({
    history: createWebHistory('/'),
    routes: [
        {
            path: '/',
            name: RouteNames.Index,
            component: MainView,
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/auth/redirect/login',
            name: 'auth-redirect-login',
            component: MainView,
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/auth/redirect/logout',
            name: 'auth-redirect-logout',
            component: AuthLogoutRedirectView,
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: `/${RouteNames.ToProcess}/:orderId?`,
            name: RouteNames.ToProcess,
            beforeEnter: orderGuard(),
            component: () => import('@/views/OrdersToProcessView.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: `/${RouteNames.Processed}`,
            name: RouteNames.Processed,
            component: () => import('@/views/OrdersProcessedView.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: `/${RouteNames.CreditNote}`,
            name: RouteNames.CreditNote,
            component: () => import('@/views/CreditNoteTransferredView.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: `/${RouteNames.SpecialCases}`,
            name: RouteNames.SpecialCases,
            component: () => import('@/views/SettingsSpecialCasesView.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: `/${RouteNames.Administrator}`,
            name: RouteNames.Administrator,
            beforeEnter: adminGuard(),
            component: () => import('@/views/AdministratorView.vue'),
        },
        {
            path: `/${RouteNames.AdminTransfer}`,
            name: RouteNames.AdminTransfer,
            beforeEnter: adminGuard(),
            component: () => import('@/views/OrdersProcessedView.vue'),
            props: { admin: true },
        },
        {
            path: `/${RouteNames.AdminCreditNote}`,
            name: RouteNames.AdminCreditNote,
            beforeEnter: adminGuard(),
            component: () => import('@/views/CreditNoteTransferredView.vue'),
            props: { admin: true },
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/',
            meta: {
                requiresAuth: false,
            },
        },
    ],
});

router.beforeEach(authGuard());

export default router;
